import React from "react";

const RemoveBrandNew = (props) => {
  return <div>RemoveBrandNew</div>;
};

export default React.memo(RemoveBrandNew);
